import { useTranslation } from 'react-i18next'
import { DateUtils } from '@ocean/utils'
import { Hint } from 'modules/simulatorTrainings/common/components/common'
import { namespace } from 'modules/simulatorTrainings/common/localization'
import { SimulatorTrainingMaintenancePeriod } from 'modules/simulatorTrainings/common/types'
import { Container } from './MaintenancePeriod.styled'

const I18_PATH = `${namespace}:simulatorTraining.maintenancePeriod`

type MaintenancePeriodProps = {
  period?: SimulatorTrainingMaintenancePeriod
}

const MaintenancePeriod: React.FC<MaintenancePeriodProps> = ({ period }) => {
  const { t } = useTranslation()

  if (!period) return null

  const { startDate, endDate } = period

  return (
    <Container>
      <Hint>
        {t(`${I18_PATH}.message`, {
          startDate: DateUtils.formatMonthDateTime(startDate),
          endDate: DateUtils.formatMonthDateTime(endDate),
        })}
      </Hint>
    </Container>
  )
}

export default MaintenancePeriod
